import { ThemeProvider } from "@emotion/react";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import NearMeOutlined from "@mui/icons-material/NearMeOutlined";
import NotificationsIcon from "@mui/icons-material/NotificationsNoneOutlined";
import AppBar from "@mui/material/AppBar";
import Badge from "@mui/material/Badge";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useNavigate } from "react-router-dom";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#c1c1c1",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const NameTypography = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  color: "#ffffff",
  fontWeight: "bold",
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#36899f",
    color: "#36899f",
    "&::after": {
      position: "relative",
      width: "150%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));



const DMessageHeader = (props: any) => {
  const history = useNavigate();

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="relative"
          color="primary"
          sx={{
            top: 0,
            width: "100%",
            // paddingX: "38px",
            // marginTop: "65px",
            // paddingBottom: "20px",
            padding: "2rem 1rem",
            marginBottom: "2rem",
            boxShadow: "5px 15px 7px 5px rgba(255,255,255,0.06235294117647059)",
          }}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={6} style={{display:"flex", alignItems:"center"}}>
              <div onClick={() => history("/")}>
                <ArrowBackIos />
              </div>
              <NameTypography style={{ fontSize: "23px" }}>
                Your Inbox
              </NameTypography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid
              item
              xs={4}
              sx={{ display: "flex", justifyContent: "end", gap: "30px" }}
            >
              <IconButton
                size="large"
                aria-label="show 17 new notifications"
                color="secondary"
                sx={{ padding: "unset" }}
              >
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  variant="dot"
                >
                  <div onClick={() => history("/notification")}>
                    <NotificationsIcon sx={{ fontSize: "larger" }} />
                  </div>
                </StyledBadge>
              </IconButton>
              <IconButton
                size="large"
                aria-label="show 17 new notifications"
                color="secondary"
                sx={{ padding: "unset" }}
              >
                <div onClick={() => history("/message")}>
                  <NearMeOutlined
                    sx={{ fontSize: "larger", color: "#ffffff" }}
                  />
                </div>
              </IconButton>
            </Grid>
          </Grid>
        </AppBar>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default DMessageHeader;
